const local = require('./local');
const development = require('./development');
const test = require('./test');
const staging = require('./staging');
const preprod = require('./preprod');
const production = require('./production');
const custom = require('./custom');

const config =
  {
    local,
    development,
    test,
    staging,
    preprod,
    production,
  }[process.env.NODE_ENV || 'local'] || custom;

module.exports = config;
